(() => {
  const ZERO_CENTS_AR = /(\$\s?(?:\d{1,3}(?:\.\d{3})+|\d+)),00\b/g;
  const ZERO_CENTS_US = /(\$\s?(?:\d{1,3}(?:,\d{3})+|\d+))\.00\b/g;
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'SELECT', 'OPTION', 'TEMPLATE']);
  let raf = 0;

  const clean = (value) =>
    typeof value === 'string'
      ? value.replace(ZERO_CENTS_AR, '$1').replace(ZERO_CENTS_US, '$1')
      : value;

  const shouldSkip = (node) => {
    const parent = node.parentElement;
    return !parent || SKIP_TAGS.has(parent.tagName) || parent.closest('[data-gd-price-cleanup-ignore]');
  };

  const cleanTextNode = (node) => {
    if (shouldSkip(node)) return;
    const next = clean(node.nodeValue);
    if (next !== node.nodeValue) node.nodeValue = next;
  };

  const cleanElement = (el) => {
    if (!(el instanceof Element) || SKIP_TAGS.has(el.tagName)) return;

    ['aria-label', 'title'].forEach((attr) => {
      const current = el.getAttribute(attr);
      if (!current) return;
      const next = clean(current);
      if (next !== current) el.setAttribute(attr, next);
    });

    if (el.shadowRoot) walk(el.shadowRoot);
  };

  const walk = (root) => {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT,
      {
        acceptNode(node) {
          if (node.nodeType === Node.ELEMENT_NODE && SKIP_TAGS.has(node.tagName)) {
            return NodeFilter.FILTER_REJECT;
          }
          return NodeFilter.FILTER_ACCEPT;
        },
      }
    );

    let node = walker.currentNode;
    while (node) {
      if (node.nodeType === Node.TEXT_NODE) cleanTextNode(node);
      if (node.nodeType === Node.ELEMENT_NODE) cleanElement(node);
      node = walker.nextNode();
    }
  };

  const apply = () => {
    raf = 0;
    if (document.body) walk(document.body);
  };

  const schedule = () => {
    if (!raf) raf = requestAnimationFrame(apply);
  };

  const start = () => {
    apply();
    new MutationObserver(schedule).observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true,
    });
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('shopify:section:select', schedule);
    document.addEventListener('shopify:block:select', schedule);
    window.addEventListener('pageshow', schedule, { passive: true });
    [200, 700, 1500, 3000].forEach((ms) => setTimeout(apply, ms));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
